var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column mt-3"},[_c('label',{staticClass:"font-14",attrs:{"for":""}},[_vm._v("\n        Design personalizado da galeria\n    ")]),_vm._v(" "),_c('flicker-carousel',{attrs:{"activeItemValue":_vm.galleryActive,"items":_vm.galleries.filter(function (item) {
            return !item.hasComments && !item.hasSidebar
        }),"handleClick":_vm.handleClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f9b1b92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/SettingFrameTypeGallery.vue
// module id = 1937
// module chunks = 5